import { STRICT_TIME_PATTERN } from '../../../../constants';
import { parseTimeOnlyValue } from './parseTimeOnlyValue';

// Accept only canonical zero-padded HH:mm(:ss); looser shapes parseTimeOnlyValue tolerates (e.g. "9:5", "0:00") are rejected here.
export const parseStrictTimeValue = (value: string): Date | null => {
  if (!STRICT_TIME_PATTERN.test(value)) return null;
  return parseTimeOnlyValue(value);
};
